import { CrewLiveEventPusher } from "../CrewLiveEventPusher";
import { v4 as uuidv4 } from "uuid";
import { Client } from "urql";
import { LiveEventUbInputType } from "../../gql/graphql";
import { DiscoverEventName } from "./Discover";

export function pushDiscovery(
  graphQlClient: Client,
  deviceIdentifier: string,
  currentCrewIdentifier: string,
): void {
  CrewLiveEventPusher.offerCrewLiveEvent(
    buildDiscoverEvent(currentCrewIdentifier, deviceIdentifier),
    graphQlClient,
  )
    .then((r) => {
      console.debug(`${DiscoverEventName} pushed: ${r}`);
      return r;
    })
    .catch((e) => console.error("pushDiscovery failed.", e));
}

function buildDiscoverEvent(
  currentCrewIdentifier: string,
  deviceIdentifier: string,
): LiveEventUbInputType {
  return {
    eventName: DiscoverEventName,
    eventID: uuidv4(),
    crewId: currentCrewIdentifier,
    deviceIdentifier: deviceIdentifier,
    deviceReadableName: null,
    payload: JSON.stringify({}),
    timestamp: new Date(),
  };
}
